import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
import { useTheme } from "../context/ThemeContext.js";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};
const ContactUsResponses = () => {
  const [contactResponses, setContactResponses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  const isSubscribed = subscriptionStatus();
  const { theme } = useTheme();

  useEffect(() => {
    fetchData();
  }, [filters, sortField, sortOrder, currentPage]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
      };
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      const filterParams = new URLSearchParams(filterParamsObj).toString();

      // Fetch responses
      const { data: contactResponses, pagination } = await fetchDataFromAPI(
        `/api/contact_us/responses`,
        filterParams,
        token
      );
      console.log("resposne", contactResponses);
      setContactResponses(contactResponses || []);
      setTotalPages(pagination?.totalPages || 1);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching responses:", err.message);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/contact_us/responses/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting response:", err);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchData();
  };

  const handleSort = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };
  const handleEdit = async (id, updatedData) => {
    try {
      await saveData(`/api/contact_us/responses/${id}`, updatedData);
      fetchData();
    } catch (err) {
      console.error("Error editing response:", err);
    }
  };
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchData();
  };

  const valueStyles = {
    true: { backgroundColor: "green", color: "white" },
    false: { backgroundColor: "red", color: "white" },
  };

  const columns = [
    { header: "ID", accessor: "id", type: "showOnly" },
    { header: "Full Name", accessor: "full_name", type: "showOnly" },
    { header: "Email", accessor: "email", type: "showOnly" },
    {
      header: "Message",
      accessor: "message",
      type: "showOnly",
      maxWidth: "200px",
      truncate: true,
    },
    {
      header: "Replied",
      accessor: "replied",
      type: "dropdown",
      options: [
        { value: "replied", label: "replied" },
        { value: "notreplied", label: "notreplied" },
      ],
      valueStyles,
    },
    {
      header: "Created At",
      accessor: "created_at",
      type: "showOnly",
    },
  ];
  const sendReplyEmail = (row) => {
    const replyMessage = "Your reply message here"; // You can replace this with dynamic input or modal data
    const recipientEmail = row.email;
    const subject = encodeURIComponent(
      `Reply to Your Contact Form Submission: ${row.full_name}`
    );
    const body = encodeURIComponent(
      `Hello ${row.full_name},\n\n${replyMessage}\n\nBest Regards,\nSpade`
    );
    const mailtoLink = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;

    window.location.href = mailtoLink; // Open the default email client with pre-filled data
  };
  return (
    <DataTable
      title="Contact Us Responses"
      columns={columns}
      data={contactResponses}
      currentPage={currentPage}
      totalPages={totalPages}
      onSort={handleSort}
      sortField={sortField}
      sortOrder={sortOrder}
      setData={setContactResponses}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
        {
          label: "Send Reply",
          onClick: (row) => sendReplyEmail(row.id), // Trigger the email function
        },
      ]}
      apiEndpoint="/api/contact_us/responses"
      itemsPerPage={10}
      getRangeInputProps={getRangeInputProps}
      fetchData={fetchData}
    />
  );
};

export default ContactUsResponses;
